import {FC} from 'react';
//mui
import {Box, SxProps, Theme, Typography} from '@mui/material';
//icons
import {ReactComponent as LogoIcon} from '@icons/logo-blue.svg';
//constants
import {BODY1, H5} from '@/utils/constants';
//styles
import {headerFormStyle} from './HeaderForm.styles';

interface HeaderFormProps {
	title: string;
	description?: string;
	sx?: SxProps<Theme>;
}

const HeaderForm: FC<HeaderFormProps> = ({title, description, sx}) => {
	return (
		<Box sx={{...sx, ...headerFormStyle.wrapper}}>
			{/* {description && ( */}
			<Box sx={headerFormStyle.logo}>
				<LogoIcon />
			</Box>
			{/* )} */}

			<Typography variant={H5} sx={headerFormStyle.title}>
				{title}
			</Typography>

			{description && (
				<Typography variant={BODY1} sx={headerFormStyle.description}>
					{description}
				</Typography>
			)}
		</Box>
	);
};

export default HeaderForm;
